<template>
  <div class="popuTotal-wrap">
    <div class="report-name">投放总表</div>
    <div class="filter-wrap">
      <el-form :inline="true">
        <el-form-item label="日期">
          <el-date-picker
            v-model="filterData.time"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 320px"
            :picker-options="pickerOptions"
            value-format="yyyyMMdd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="维度">
          <el-select v-model="filterData.dimension">
            <el-option label="时间" :value="0"></el-option>
            <el-option label="国家" :value="1"></el-option>
            <el-option label="产品负责人" :value="2"></el-option>
            <el-option label="项目组" :value="3"></el-option>
            <el-option label="产品组" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台类型">
          <el-select
            placeholder="平台类型"
            v-model="filterData.platform"
            multiple
            collapse-tags
            clearable
            @change="platformChange"
          >
            <el-option :value="-1" label="全部平台"></el-option>
            <el-option
              v-for="item in platformList"
              :key="item.refId"
              :label="item.name"
              :value="item.refId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区">
          <AreaMultiSelect
            :value.sync="filterData.geoList"
            :optionsList="countryList"
          >
          </AreaMultiSelect>
        </el-form-item>
        <el-form-item label="产品负责人">
          <el-select
            v-model="filterData.principalUserList"
            placeholder="全部负责人"
            multiple
            collapse-tags
            filterable
          >
            <el-option
              v-for="item of principalUserList"
              :label="item"
              :value="item"
              :key="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工作室">
          <el-select
            filterable
            collapse-tags
            multiple
            class="multiple-select"
            placeholder="请选择工作室"
            v-model="filterData.productGroupNameList"
          >
            <el-option
              v-for="item in groupList"
              :key="item.refId"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小组">
          <el-select
            filterable
            collapse-tags
            multiple
            class="multiple-select"
            placeholder="请选择小组"
            v-model="filterData.squadNameList"
          >
            <el-option
              v-for="item in studioList"
              :key="item.refId"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品分组">
          <el-select
            v-model="filterData.groupNameList"
            placeholder="全部分组"
            multiple
            collapse-tags
            filterable
          >
            <el-option
              v-for="item of groupNameList"
              :label="item"
              :value="item"
              :key="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="域名组">
          <el-select
            v-model="filterData.accountGroupCodes"
            multiple
            collapse-tags
            placeholder="请选择域名组"
            clearable
            style="width: 200px"
          >
            <el-option
              v-for="item in accountGroupCodeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-wrap">
      <el-popover placement="bottom-start" width="300" trigger="hover">
        <el-button
          slot="reference"
          type="primary"
          style="margin-bottom: 16px"
          @click="columnSortModal"
          >表头排序
        </el-button>
        <div class="define-wrap">
          <div class="title">常用自定义列</div>
          <div v-if="tableDefineList.length > 0" style="margin-top: 15px">
            <div
              v-for="(item, index) in tableDefineList"
              :key="item.id"
              class="list-item"
            >
              <!-- 左边名称 -->
              <div style="display: flex">
                <div class="icon-wrap">
                  <i
                    class="el-icon-check"
                    v-if="currentCheckDefineIndex === index"
                  ></i>
                </div>
                <span @click="handleCheckDefine(index)">{{
                  item.templateName
                }}</span>
              </div>
              <!-- 右边操作图标 -->
              <div style="display: flex">
                <!-- 编辑 -->
                <i class="el-icon-edit" @click="handleEditDefine(index)"></i>
                <!-- 删除 -->
                <i class="el-icon-close" @click="handleDeleteDefine(index)"></i>
              </div>
            </div>
          </div>
          <div v-else>无</div>
        </div>
      </el-popover>
      <el-radio-group v-model="cashSign" size="mini" style="margin-left: 30px">
        <el-radio-button label="0">$</el-radio-button>
        <el-radio-button label="1">￥</el-radio-button>
      </el-radio-group>
      <el-table
        :data="tableList"
        border
        style="width: 100%"
        :max-height="tableMaxHeight"
        v-loading="loading"
        show-summary
        :summary-method="getSummaries"
        :key="tablekey"
      >
        <el-table-column
          :prop="tableDynamicColumn.props"
          :label="tableDynamicColumn.label"
          resizeable
        ></el-table-column>
        <el-table-column label="合计" resizeable>
          <el-table-column prop="cost-1" min-width="130">
            <template v-slot:header>
              <div class="cash-sign-wrap">
                <span>推广合计</span>
              </div>
            </template>
            <template slot-scope="scope">
              {{
                cashSign === "0"
                  ? `$ ${scope.row["cost-1"][0]}`
                  : `￥ ${scope.row["cost-1"][1]}`
              }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :label="item.headerName"
          v-for="item in totalColumn"
          :key="item.headerColumn"
          resizeable
        >
          <el-table-column :prop="item.headerColumn" label="推广合计">
            <template slot-scope="scope">
              {{
                scope.row[item.headerColumn] === "0.0"
                  ? cashSign === "0"
                    ? "$ 0.0"
                    : "￥ 0.0"
                  : cashSign === "0"
                  ? `$ ${scope.row[item.headerColumn][0]}`
                  : `￥ ${scope.row[item.headerColumn][1]}`
              }}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <ColumnSortModal
      ref="columnSortRef"
      @updateSortList="handleChangeSortList"
    />
  </div>
</template>

<script>
import moment from "moment";
import { dimension } from "./columns";
import ColumnSortModal from "./columnSortModal.vue";
import AreaMultiSelect from "@/components/areaMultiSelect.vue";
import { getTotalReportParams, getTotalTableList } from "@/api/popuTotal.js";
import { getTagPropertySelectList } from "@/api/property.js";
import { groupList, squadList, getCountryListFetch } from "@/api/api";
import { searchDefineColumn, deleteDefineColumn } from "@/api/tableSort.js";
export default {
  name: "LtvReport",
  components: {
    ColumnSortModal,
    AreaMultiSelect,
  },
  data() {
    return {
      cashSign: "0",
      tableMaxHeight: window.innerHeight - 350,
      groupNameList: [],
      principalUserList: [],
      productGroupNameList: [],
      groupList: [],
      studioList: [],
      accountGroupCodeList: JSON.parse(
        localStorage.getItem("accountGroupCodeList") || "[]"
      ),
      // 平台类型
      platformList: [],
      pageData: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      // 表格动态列
      tableDynamicColumn: {
        props: null,
        label: null,
      },
      filterData: {
        // 维度
        dimension: 0,
        time: [
          moment().subtract(7, "days").format("YYYYMMDD"),
          moment().subtract(1, "days").format("YYYYMMDD"),
        ],
        // 产品分组
        groupNameList: [],
        // 平台类型
        platform: [],
        // 产品负责人
        principalUserList: [],
        // 工作室
        productGroupNameList: [],
        // 小组
        squadNameList: [],
        // 地区
        geoList: [],
        // 域名组
        accountGroupCodes: [],
      },
      loading: false,
      // 地区列表
      countryList: [],
      tableCols: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              picker.$emit("pick", [
                moment().subtract(7, "days").format("YYYYMMDD"),
                moment().subtract(1, "days").format("YYYYMMDD"),
              ]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              picker.$emit("pick", [
                moment().subtract(30, "days").format("YYYYMMDD"),
                moment().subtract(1, "days").format("YYYYMMDD"),
              ]);
            },
          },
          {
            text: "最近二个月",
            onClick(picker) {
              picker.$emit("pick", [
                moment().subtract(60, "days").format("YYYYMMDD"),
                moment().subtract(1, "days").format("YYYYMMDD"),
              ]);
            },
          },
        ],
      },
      tableList: [],
      tablekey: Math.random(),
      // 所有平台类型
      originTotalColumn: [],
      totalColumn: [],
      // 表头排序—常用列列表
      tableDefineList: [],
      // 当前默认选中的表格列
      currentDefaultTableList: null,
      // 当前表格可展示的列
      currentDisplayColumn: [],
      // 当前选中的自定义列表
      currentCheckDefineIndex: null,
    };
  },
  watch: {
    currentCheckDefineIndex: {
      handler(val) {
        if (val !== null) {
          const column = JSON.parse(this.tableDefineList[val].templateData);
          const resultColum = [];
          // 常用列匹配当前表格可展示的数据列
          column.forEach((item) => {
            const gIndex = this.currentDisplayColumn.findIndex(
              (i) => i.headerName === item.headerName
            );
            if (gIndex !== -1) {
              resultColum.push(this.currentDisplayColumn[gIndex]);
            }
          });
          0;
          this.totalColumn = resultColum;
        } else {
          if (this.currentDefaultTableList) {
            const resultColum = [];
            this.currentDefaultTableList.forEach((item) => {
              const gIndex = this.currentDisplayColumn.findIndex(
                (i) => i.headerName === item.headerName
              );
              if (gIndex !== -1) {
                resultColum.push(this.currentDisplayColumn[gIndex]);
              }
            });
            this.totalColumn = resultColum;
          } else {
            this.totalColumn = this.currentDisplayColumn;
          }
        }
        this.tablekey = Math.random();
      },
    },
  },
  mounted() {
    this.tableDynamicColumn = {
      props: dimension.get(this.filterData.dimension).column,
      label: dimension.get(this.filterData.dimension).name,
    };
    this.initSelect();
    this.searchData();
    // 获取自定义列
    this.handleDisplayPopover();
  },
  methods: {
    // 获取表头排序自定义列表
    handleDisplayPopover() {
      searchDefineColumn().then((res) => {
        if (res.code === "0000") {
          this.tableDefineList = res.data;
        }
      });
    },
    handleCheckDefine(index) {
      if (index === this.currentCheckDefineIndex) {
        this.currentCheckDefineIndex = null;
      } else {
        this.currentCheckDefineIndex = index;
      }
    },
    handleDeleteDefine(index) {
      deleteDefineColumn({
        id: this.tableDefineList[index].id,
      }).then(() => {
        this.handleDisplayPopover();
      });
    },
    handleEditDefine(index) {
      this.$refs.columnSortRef.showModal(
        this.originTotalColumn,
        this.tableDefineList[index],
        index
      );
    },
    platformChange(value) {
      if (value.includes(-1)) {
        this.filterData.platform = this.platformList.map((o) => o.refId);
      }
    },
    // 表头排序自定义事件
    handleChangeSortList(column, currentEditIndex) {
      // 根据当前页面表格可展示的列进行筛选
      if (
        currentEditIndex == null ||
        (currentEditIndex >= 0 &&
          currentEditIndex === this.currentCheckDefineIndex)
      ) {
        let resultColum = [];
        column.forEach((item) => {
          const gIndex = this.currentDisplayColumn.findIndex(
            (i) => i.headerName === item.headerName
          );
          if (gIndex !== -1) {
            resultColum.push(this.currentDisplayColumn[gIndex]);
          }
        });

        this.totalColumn = resultColum;
      }
      this.currentDefaultTableList = JSON.parse(JSON.stringify(column));
      this.tablekey = Math.random();
      this.handleDisplayPopover();
    },
    columnSortModal() {
      if (this.currentCheckDefineIndex !== null) {
        // 如果当前有选中的常用列
        this.$refs.columnSortRef.showModal(
          this.originTotalColumn,
          this.tableDefineList[this.currentCheckDefineIndex]
        );
      } else {
        // 没有选中的常用列
        this.$refs.columnSortRef.showModal(this.originTotalColumn);
      }
    },
    // 产品下拉
    initSelect() {
      getTotalReportParams().then((res) => {
        if (res.code === "0000") {
          this.groupNameList = res.groupNameList;
          this.principalUserList = res.principalUserList;
          this.productGroupNameList = res.productGroupNameList;
        }
      });
      getCountryListFetch().then((res) => {
        this.countryList = res.countryList;
      });
      groupList().then((res) => {
        this.groupList = res.data;
      });
      squadList().then((res) => {
        this.studioList = res.data;
      });
      // 平台类型
      getTagPropertySelectList({
        type: 10,
      }).then((res) => {
        this.platformList = res.data;
        // 表头排序展示所有的平台类型
        this.originTotalColumn = res.data.map((item) => {
          return {
            headerName: item.name,
          };
        });
      });
    },
    formatData() {
      let data = {
        startDate: parseInt(this.filterData.time[0]),
        endDate: parseInt(this.filterData.time[1]),
      };

      for (let key in this.filterData) {
        if (key !== "time") {
          data[key] = JSON.parse(JSON.stringify(this.filterData[key]));
        }
        if (key === "accountGroupCodes") {
          data[key] = this.filterData.accountGroupCodes.length
            ? [...this.filterData.accountGroupCodes]
            : undefined;
        }
      }

      return data;
    },
    searchData() {
      this.loading = true;
      let parmas = this.formatData();
      // 保存当前选中的常用列index
      let currentCheckIndex = this.currentCheckDefineIndex;
      this.currentCheckDefineIndex = null;
      getTotalTableList(parmas).then((res) => {
        this.tableDynamicColumn = {
          props: dimension.get(this.filterData.dimension).column,
          label: dimension.get(this.filterData.dimension).name,
        };
        this.tablekey = Math.random();
        this.loading = false;
        if (res.code === "0000") {
          this.totalColumn = res.data.reportHeaders
            ? res.data.reportHeaders
            : [];
          // 当前表格列可展示的数据
          this.currentDisplayColumn = res.data.reportHeaders
            ? res.data.reportHeaders
            : [];
          const headerColumn = res.data.reportHeaders
            ? res.data.reportHeaders.map((item) => item.headerColumn)
            : [];
          this.tableList = res.data.reportHeaders
            ? res.data.popuReportDataList.map((item) => {
                const itemColumn = Object.keys(item);
                const itemObj = {};
                // 表头有的但列表中没有的字段
                headerColumn.forEach((o) => {
                  if (itemColumn.findIndex((i) => i === o) === -1) {
                    itemObj[o] = "0.0";
                  }
                });

                return {
                  ...item,
                  ...itemObj,
                };
              })
            : [];

          this.$nextTick(() => {
            if (currentCheckIndex !== null) {
              // 当前如果选择了常用列
              this.currentCheckDefineIndex = currentCheckIndex;
            } else {
              if (this.currentDefaultTableList) {
                let resultColum = [];
                // 更新当前可展示列后进行筛选
                this.currentDefaultTableList.forEach((g) => {
                  const gIndex = this.currentDisplayColumn.findIndex(
                    (d) => d.headerName === g.headerName
                  );
                  if (gIndex !== -1) {
                    resultColum.push(this.currentDisplayColumn[gIndex]);
                  }
                });

                this.totalColumn = resultColum;
                this.tablekey = Math.random();
              }
            }
          });
        }
      });
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      for (let index = 0; index < columns.length; index++) {
        if (index === 0) {
          sums[index] = "总计";
        }
      }
      return [];
    },
    handleCashSign(value) {
      console.log(value);
    },
  },
};
</script>

<style lang="less" scoped>
.popuTotal-wrap {
  padding: 16px;
  box-sizing: border-box;
  .report-name {
    padding: 0px 16px 6px 0px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .filter-wrap {
    margin-top: 10px;
    .multipleselect ::v-deep .el-input__inner {
      &::placeholder {
        color: #777777 !important;
      }
    }
    .input-search {
      width: 90%;
      margin-left: 5%;
    }
  }
  .table-wrap {
    margin-top: 15px;
    .top-btn {
      color: #2a56e3;
      font-size: 14px;
      border-radius: 2px;
      border: 1px solid #2a56e3;
      background: rgba(255, 255, 255, 1);
      .pl-icon {
        margin-right: 8px;
      }
    }
    .cash-sign-wrap {
      display: flex;
      align-items: center;
      > * {
        margin-right: 15px;
      }
    }
  }
}
.define-wrap {
  .title {
    display: flex;
    justify-content: center;
    color: #999;
  }
  .list-item {
    padding: 8px;
    cursor: pointer;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-wrap {
      width: 30px;
      height: 20px;
      .el-icon-check {
        font-size: 16px;
        margin-right: 8px;
        color: #1890ff;
      }
    }
    .el-icon-edit {
      font-size: 16px;
      margin-left: 8px;
      margin-right: 8px;
      display: none;
    }
    .el-icon-close {
      font-size: 16px;
      display: none;
    }

    &:hover {
      background: #f5f5f5;
      .el-icon-edit {
        display: inline;
      }
      .el-icon-close {
        display: inline;
      }
    }
  }
}
</style>
